import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import {
  startGetOrdenPagoItemsXLS,
  startGetAsistenciasSinPago
} from '../../context/actions/ordenesPagoActions';
import {
  startGetOrdenesValidarFactura,
  startPostCrearOrdenPagoV2,
  setPagos2Filters,
  startDescargarOpXls,
  startEnviarOpPorEmail,
  startUpdateEstadoPago,
  startCrearOrdenPagoConcesionados,
  startSetOpArchivado,
  startDownloadDocumentoOPV2,
  startGetXlsSinComplementoPago
} from '../../context/actions/pagos2Actions';

export const usePagosV2Page = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { ordenesPagoValidarFactura, asistenciasElegibles2, creandoOrdenPago, loadingPagos2, pagos2Filters } = useSelector(
    (state) => state.ordenesPagoReducer
  );
  const { email } = useSelector((state) => state.userReducer.user);

  const [modalBusquedaVisible, setModalBusquedaVisible] = useState(false);
  const [modalCargaMasivaVisible, setModalCargaMasivaVisible] = useState(false);
  const [modalCargaMasivaXLSXVisible, setModalCargaMasivaXLSXVisible] = useState(false);
  const [modalEmailVisible, setModalEmailVisible] = useState(false);
  const [modalPagoDirectoVisible, setModalPagoDirectoVisible] = useState(false);
  const [modalConcesionadosVisible, setModalConcesionadosVisible] = useState(false);
  const [ordenPagoSeleccionada, setOrdenPagoSeleccionada] = useState(null);
  const [emails, setEmails] = useState('');
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingPagoDirecto, setLoadingPagoDirecto] = useState(false);
  const [loadingConcesionados, setLoadingConcesionados] = useState(false);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);
  const [asistenciasSeleccionadas, setAsistenciasSeleccionadas] = useState([]);

  const [estatusSeleccionado, setEstatusSeleccionado] = useState(pagos2Filters.estatusSeleccionado);
  const [currentPage, setCurrentPage] = useState(pagos2Filters.currentPage || 1);
  const [pageSize, setPageSize] = useState(pagos2Filters.pageSize || 10);
  const [filtrosColumnas, setFiltrosColumnas] = useState(pagos2Filters.filtrosColumnas || {});
  const [sortOrder, setSortOrder] = useState(pagos2Filters.sortOrder || { columnKey: 'ordenPagoID', order: 'descend' });
  const [loadingDescarga, setLoadingDescarga] = useState({})

  const estatusOptions = [
    { value: 1, label: 'Orden creada - Por validar contencion' },
    { value: 2, label: 'Orden creada - Por validar 1er nivel' },
    { value: 3, label: 'Orden creada - Por validar 2do nivel' },
    { value: 4, label: 'Orden validada - Por solicitar factura' },
    { value: 5, label: 'Factura solicitada - Por cargar factura' },
    { value: 6, label: 'Factura cargada - Por validar Factura' },
    { value: 7, label: 'Factura validada - Por marcar Pagado' },
    { value: 8, label: 'Factura pagada - Por cargar Comprobante' },
    { value: 9, label: 'Comprobante cargado - Por cargar complemento' },
    { value: 10, label: 'Archivados' },
    { value: 11, label: 'Rechazados' }
  ];


  useEffect(() => {
    dispatch(startGetAsistenciasSinPago());
  }, [dispatch]);

  useEffect(() => {
    if (estatusSeleccionado) {
      dispatch(setPagos2Filters({
        estatusSeleccionado,
        currentPage,
        filtrosColumnas,
        sortOrder
      }));

      dispatch(startGetOrdenesValidarFactura(estatusSeleccionado));
    }
  }, [dispatch, estatusSeleccionado]);

  const handleGenerarOP = () => {
    if (asistenciasSeleccionadas.length === 0 || !proveedorSeleccionado) {
      message.warning('Selecciona un proveedor y al menos una asistencia');
      return;
    }

    const asistencias = asistenciasSeleccionadas.map(a => a.asistenciaID);
    const campaniaID = asistenciasSeleccionadas[0]?.campaniaID;

    if (!campaniaID) {
      message.error('No se pudo obtener el ID de la campaña');
      return;
    }

    const body = {
      asistencias,
      proveedorID: proveedorSeleccionado,
      campaniaID
    };

    dispatch(startPostCrearOrdenPagoV2(body)).then((ordenPagoID) => {
      if (ordenPagoID) {
        setModalBusquedaVisible(false);
        setAsistenciasSeleccionadas([]);
        setProveedorSeleccionado(null);
        dispatch(startGetOrdenesValidarFactura());
        dispatch(startGetAsistenciasSinPago());
        history.push(`/ordenesPagoV2/detalle/${ordenPagoID}`);
      }
    });
  };

  const handlePagoDirecto = () => {
    if (asistenciasSeleccionadas.length === 0 || !proveedorSeleccionado) {
      message.warning('Selecciona un proveedor y al menos una asistencia');
      return;
    }

    setModalBusquedaVisible(false);
    setModalPagoDirectoVisible(true);
  };

  const handlePagoDirectoSuccess = async (responseData) => {
    setModalPagoDirectoVisible(false);
    setLoadingPagoDirecto(false);
    setAsistenciasSeleccionadas([]);
    setProveedorSeleccionado(null);
    await dispatch(startGetOrdenesValidarFactura());
    await dispatch(startGetAsistenciasSinPago());

    if (responseData && responseData.ordenPagoID) {
      history.push(`/ordenesPagoV2/detalle/${responseData.ordenPagoID}`);
    }
  };

  const handlePagoDirectoCancel = () => {
    setModalPagoDirectoVisible(false);
    setModalBusquedaVisible(true);
  };

  const handleConcesionados = async () => {
    if (asistenciasSeleccionadas.length === 0 || !proveedorSeleccionado) {
      message.warning('Selecciona un proveedor y al menos una asistencia');
      return;
    }

    setModalBusquedaVisible(false);
    setModalConcesionadosVisible(true);
  };

  const handleConcesionadosSuccess = async (responseData) => {
    setModalConcesionadosVisible(false);
    setLoadingConcesionados(false);
    setAsistenciasSeleccionadas([]);
    setProveedorSeleccionado(null);
    await dispatch(startGetOrdenesValidarFactura());

    if (responseData && responseData.ordenPagoID) {
      history.push(`/ordenesPagoV2/detalle/${responseData.ordenPagoID}`);
    }
  };

  const handleConcesionadosCancel = () => {
    setModalConcesionadosVisible(false);
    setModalBusquedaVisible(true);
  };

  const handleRefresh = () => {
    dispatch(startGetOrdenesValidarFactura(estatusSeleccionado));
  };

  const handleCargaMasivaSuccess = () => {
    handleRefresh();
  };

  const handleDescargarXLS = (ordenPagoID) => {
    dispatch(startGetOrdenPagoItemsXLS(ordenPagoID));
  };

  const handleDescargarOpXls = () => {
    dispatch(startDescargarOpXls(estatusSeleccionado));
  };

  const handleDescargarXlsComplementosPago = (anio) => {
    return dispatch(startGetXlsSinComplementoPago(anio));
  };

  const handleAutorizarMasivo = () => {
    history.push('/ordenesPago/autorizarMasivo');
  };

  const handleVerDetalle = (record) => {
    history.push(`/ordenesPagoV2/detalle/${record.ordenPagoID}`);
  };

  const handleSolicitarFactura = (record) => {
    setOrdenPagoSeleccionada(record);
    setEmails('');
    setModalEmailVisible(true);
  };

  const handleEnviarEmail = async (emailsString) => {
    if (!emailsString || !emailsString.trim() || !ordenPagoSeleccionada) return;

    setLoadingEmail(true);

    try {
      await dispatch(startEnviarOpPorEmail(ordenPagoSeleccionada.ordenPagoID, emailsString));
      setModalEmailVisible(false);
      setEmails('');
      setOrdenPagoSeleccionada(null);
      handleRefresh();
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleFacturaPagada = async (record) => {
    await dispatch(startUpdateEstadoPago(record.ordenPagoID));
    handleRefresh();
  };

  const handleArchivar = async (record) => {
    const archivado = !record.archivado;
    const result = await dispatch(startSetOpArchivado(record.ordenPagoID, archivado));
    if (result.success) {
      handleRefresh();
    }
  };

  const handleDescargarDocumento = async (record) => {
    setLoadingDescarga(prev => ({ ...prev, [record.ordenPagoID]: true }));

    try {
      await dispatch(startDownloadDocumentoOPV2(record.ordenPagoID, 1));
    } finally {
      setLoadingDescarga(prev => ({ ...prev, [record.ordenPagoID]: false }));
    }
  }; 

  const busquedaProps = useMemo(() => ({
    proveedores: asistenciasElegibles2?.proveedores || [],
    asistencias: asistenciasElegibles2?.asistencias || [],
    proveedorSeleccionado,
    setProveedorSeleccionado,
    asistenciasSeleccionadas,
    setAsistenciasSeleccionadas,
    onGenerarOP: handleGenerarOP,
    onPagoDirecto: handlePagoDirecto,
    onConcesionados: handleConcesionados,
    creandoOrdenPago,
    loadingConcesionados
  }), [
    asistenciasElegibles2,
    proveedorSeleccionado,
    asistenciasSeleccionadas,
    creandoOrdenPago,
    loadingConcesionados
  ]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    dispatch(setPagos2Filters({
      estatusSeleccionado,
      currentPage: page,
      pageSize: size,
      filtrosColumnas,
      sortOrder
    }));
  };

  const handleActualizarFiltrosColumnas = (filtros) => {
    setFiltrosColumnas(filtros);
    dispatch(setPagos2Filters({
      estatusSeleccionado,
      currentPage,
      filtrosColumnas: filtros,
      sortOrder
    }));
  };

  const handleActualizarSortOrder = (sorter) => {
    setSortOrder(sorter);
    dispatch(setPagos2Filters({
      estatusSeleccionado,
      currentPage,
      filtrosColumnas,
      sortOrder: sorter
    }));
  };

  const tablaProps = useMemo(() => {
    const dataFiltrada = estatusSeleccionado
      ? (ordenesPagoValidarFactura || []).filter(record => {
        if (email !== 'angelica.herrera@escotel.com.mx') return true;

        return !(record.tipoOp === 3 && record.fechaCargaFactura === '-');
      })
      : [];

    return {
      dataSource: dataFiltrada,
      loading: loadingPagos2,
      onVerDetalle: handleVerDetalle,
      currentPage,
      pageSize,
      onPageChange: handlePageChange,
      estatusSeleccionado,
      onSolicitarFactura: handleSolicitarFactura,
      onFacturaPagada: handleFacturaPagada,
      onArchivar: handleArchivar,
      onDescargarDocumento: handleDescargarDocumento,
      loadingDescarga,
      filtrosColumnas,
      onActualizarFiltrosColumnas: handleActualizarFiltrosColumnas,
      sortOrder,
      onActualizarSortOrder: handleActualizarSortOrder
    };
  }, [ordenesPagoValidarFactura, loadingPagos2, estatusSeleccionado, currentPage, pageSize, filtrosColumnas, sortOrder, loadingDescarga, email]);

  const accionesProps = useMemo(() => ({
    refresh: {
      onClick: handleRefresh,
      loading: loadingPagos2
    }
  }), [loadingPagos2]);

  return {
    busquedaProps,
    tablaProps,
    accionesProps,
    modalBusquedaVisible,
    setModalBusquedaVisible,
    loadingPagos2,
    estatusSeleccionado,
    setEstatusSeleccionado,
    estatusOptions,
    modalCargaMasivaVisible,
    setModalCargaMasivaVisible,
    modalCargaMasivaXLSXVisible,
    setModalCargaMasivaXLSXVisible,
    modalEmailVisible,
    setModalEmailVisible,
    emails,
    setEmails,
    loadingEmail,
    handleEnviarEmail,
    ordenPagoSeleccionada,
    handleCargaMasivaSuccess,
    handleDescargarOpXls,
    handleDescargarXlsComplementosPago,
    handleAutorizarMasivo,
    modalPagoDirectoVisible,
    setModalPagoDirectoVisible,
    loadingPagoDirecto,
    setLoadingPagoDirecto,
    handlePagoDirectoSuccess,
    handlePagoDirectoCancel,
    asistenciasSeleccionadas,
    modalConcesionadosVisible,
    setModalConcesionadosVisible,
    loadingConcesionados,
    setLoadingConcesionados,
    handleConcesionadosSuccess,
    handleConcesionadosCancel
  };
};
